import React from 'react';
import FamilyPlanningCatalogManager from '../../head-doctor/familyPlanning/FamilyPlanningCatalogManager';
import { MAJOR_COPY } from '../majorCopy';

export default function MajorFamilyPlanningPage() {
  return (
    <FamilyPlanningCatalogManager
      copy={MAJOR_COPY.FAMILY_PLANNING_CATALOG}
      pageClassName="hd-nursing-care-page"
    />
  );
}
